var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorLightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2333 1.30859H1.73682V23.9205H45.2333V1.30859Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73682 1.30801V18.5941C3.52954 18.9735 5.38769 19.1829 7.29819 19.1829C18.9313 19.1829 28.7847 11.698 32.3833 1.29492H1.73682V1.30801Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09238 32.2036H18.0024L15.9872 37.5687H13.9197V39.3614H33.6004V37.5687H31.5329L29.5177 32.2036H43.4277C45.4036 32.2036 47 30.6072 47 28.6313V3.57236C47 1.59644 45.4036 0 43.4277 0H4.09238C2.11646 0 0.52002 1.59644 0.52002 3.57236V28.6182C0.52002 30.5941 2.11646 32.2036 4.09238 32.2036ZM29.6354 37.5687H17.9108L19.9259 32.2036H27.6334L29.6354 37.5687ZM45.2466 28.6182C45.2466 29.6127 44.4483 30.4109 43.4538 30.4109H4.09238C3.09788 30.4109 2.29966 29.6127 2.29966 28.6182V24.9411H45.2335L45.2466 28.6182ZM2.31274 3.57236C2.31274 2.57786 3.11097 1.77964 4.10547 1.77964H43.4538C44.4483 1.77964 45.2466 2.57786 45.2466 3.57236V23.1615H2.31274V3.57236Z",
    fill: "#6d7177"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7733 28.9988C24.5032 28.9988 25.0949 28.407 25.0949 27.6771C25.0949 26.9472 24.5032 26.3555 23.7733 26.3555C23.0434 26.3555 22.4517 26.9472 22.4517 27.6771C22.4517 28.407 23.0434 28.9988 23.7733 28.9988Z",
    fill: "#6d7177"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 26,
    height: 14,
    rx: 3,
    fill: "white",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    width: 40,
    height: 3,
    rx: 1,
    fill: "white",
    fillOpacity: 0.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 4,
    width: 6,
    height: 14,
    rx: 2,
    fill: "white",
    fillOpacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 14,
    rx: 2,
    fill: "white",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.06,
    y1: 1.29492,
    x2: 17.06,
    y2: 19.1829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorLightDark);
export default __webpack_public_path__ + "static/media/monitor-light-dark.69c7eacd5657747f56188798b04a86b0.svg";
export { ForwardRef as ReactComponent };